<!-- src/app/pages/expediente/perfil-paciente/notas-internas-modal/notas-internas-modal.component.html -->

<div class="modal-overlay" (click)="onClose()">
  <div class="modal-container" (click)="$event.stopPropagation()">
    <!-- HEADER -->
    <div class="modal-header">
      <div class="header-info">
        <h2>Notas Internas del Paciente</h2>
        <p>{{ patient?.full_name || 'Sin nombre' }}</p>
      </div>
      <button class="btn-close" (click)="onClose()">
        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>

    <!-- CONTENT - 2 COLUMNAS -->
    <div class="modal-content">
      <!-- COLUMNA IZQUIERDA: INFORMACIÓN + NUEVA NOTA -->
      <div class="column-left">
        <!-- ✅ SECCIÓN SUPERIOR: INFORMACIÓN DEL PACIENTE -->
        <div class="info-section">
          <div class="section-header">
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" class="icon">
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
              />
            </svg>
            <h3>Información del Paciente</h3>
          </div>

          <div class="info-grid">
            <div class="info-item">
              <span class="info-label">Nombre:</span>
              <span class="info-value">{{ patient?.full_name || '-' }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">Edad:</span>
              <span class="info-value">{{ getEdad() }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">Seguro:</span>
              <span class="info-value">{{ patient?.insurance_name || '-' }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">Médico tratante:</span>
              <span class="info-value">{{ patient?.doctor?.nombre || '-' }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">Alergias:</span>
              <span class="info-value">{{ getAlergias() }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">Diagnóstico:</span>
              <span class="info-value">{{ patient?.cie10 || '-' }}</span>
            </div>
            <div class="info-item info-item-full">
              <span class="info-label">Última receta:</span>
              <span class="info-value">{{ getUltimaReceta() }}</span>
            </div>
          </div>
        </div>

        <!-- ✅ SECCIÓN INFERIOR: NUEVA NOTA -->
        <div class="form-section">
          <div class="section-header">
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" class="icon">
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
              />
            </svg>
            <h3>Nueva Nota</h3>
          </div>

          <div class="form-group">
            <label>Título</label>
            <input
              type="text"
              [(ngModel)]="nuevaNota.titulo"
              placeholder="Ej: Seguimiento tratamiento"
              maxlength="100"
              class="form-control"
            />
          </div>

          <div class="form-group">
            <label>Nota</label>
            <textarea
              [(ngModel)]="nuevaNota.contenido"
              placeholder="Escribe la nota aquí..."
              rows="6"
              maxlength="500"
              class="form-control"
            ></textarea>
            <div class="char-count">{{ nuevaNota.contenido.length }}/500</div>
          </div>

          <div class="form-actions">
            <button class="btn-secondary" (click)="onCancelar()">Cancelar</button>
            <button
              class="btn-primary"
              (click)="onGuardar()"
              [disabled]="!nuevaNota.titulo.trim() || !nuevaNota.contenido.trim()"
            >
              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
              </svg>
              Guardar Nota
            </button>
          </div>
        </div>
      </div>

      <!-- COLUMNA DERECHA: HISTORIAL -->
      <div class="column-right">
        <div class="section-header">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" class="icon">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
            />
          </svg>
          <h3>Historial de Notas</h3>
          <span class="badge-count">{{ notas.length }}</span>
        </div>

        <div class="notas-list">
          <div class="nota-card" *ngFor="let nota of notas">
            <div class="nota-meta">
              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" class="icon-small">
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
              <span class="fecha">{{ nota.fecha }} {{ nota.hora }}</span>
            </div>
            <div class="nota-usuario">{{ nota.usuario }}</div>
            <div class="nota-divider"></div>
            <div class="nota-titulo">{{ nota.titulo }}</div>
            <div class="nota-contenido">{{ nota.contenido }}</div>
          </div>

          <!-- EMPTY STATE -->
          <div class="empty-state" *ngIf="notas.length === 0">
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
              />
            </svg>
            <p>No hay notas registradas</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
